import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  adminApi,
  RemoveMemberResponse
} from 'services/adminApi';

interface RemoveMemberRequest {
  userId: string;
}

export const useRemoveMember = (
  options?: UseMutationOptions<
    RemoveMemberResponse,
    Error,
    RemoveMemberRequest
  >
) => {
  return useMutation<RemoveMemberResponse, Error, RemoveMemberRequest>({
    mutationFn: ({ userId }: RemoveMemberRequest) =>
      adminApi.removeMember(userId),
    ...options,
  });
};
